import { render } from "./MobileCategoriesPanel.vue?vue&type=template&id=202ef808"
import script from "./MobileCategoriesPanel.vue?vue&type=script&lang=js"
export * from "./MobileCategoriesPanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__